import { render, staticRenderFns } from "./MatsListing.vue?vue&type=template&id=da2657e6&scoped=true"
import script from "./MatsListing.vue?vue&type=script&lang=js"
export * from "./MatsListing.vue?vue&type=script&lang=js"
import style0 from "./MatsListing.vue?vue&type=style&index=0&id=da2657e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2657e6",
  null
  
)

export default component.exports